/* eslint-disable max-len */
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import React, { Component } from 'react'
import { List, fromJS, Map } from 'immutable'
import _partial from 'lodash/partial'
import _get from 'lodash/get'
import { connect as connectRedux } from 'react-redux'
import { getPrimary } from '../../services/languages/index'
import NotificationsMenu from '../NotificationsMenu/index'
import CirclesNavEntry, { getCirclesIconVariant } from '../Community/Circles/CirclesNavEntry'
import Hamburger from '../Hamburger/index'
import Button, { TYPES } from '../Button/index'
import { isPartialPathAllowed, getGiftLpUrl } from '../../services/url/index'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_BUTTON } from '../ButtonSignUp/index'
import MenuUser from '../MenuUser/index'
import AppDownloadBanner from '../AppDownloadBanner/index'
import AlertBarLoader from '../AlertBarLoader/index'
import InviteFriendPopup from '../InviteFriend/InviteFriendPopup/index'
import LanguageSelectGlobe from '../LanguageSelectGlobe/index'
import GaiaLogo, { TYPE_TEAL } from '../GaiaLogo/index'
import { getBoundActions } from '../../actions/index'
import { TYPE_LOGIN, TYPE_DAYTONA_WA_10 } from '../../services/dialog/index'
import { deactivateSubject } from '../../services/testarossa/index'
import { get as getConfig } from '../../config/index'
import { DaytonaCampaign } from '../Daytona/index'
import {
  NAVIGATION_EVENT_LABELS,
  getNavClickedGa4Event,
} from '../../services/event-tracking/index'
import Link, { TARGET_BLANK } from '../Link/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import {
  URL_CART_BILLING,
  URL_CART_BILLING_PAYMENT,
  URL_CART_CONFIRMATION,
  URL_GIFT_LP,
} from '../../services/url/constants'
import { GIFT_READY_STATE } from '../../services/gift/index'
import {
  ROLE_ID_SITE_ADMIN, ROLE_ID_DEVELOPER, ROLE_ID_QA, ROLE_ID_EDITOR,
} from '../../services/auth-access/index'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import NavigationPrimaryV2 from '../NavigationPrimaryV2/index'
import { selectMemberHomeFirstTouchHeaderContext } from '../../services/app/selectors'

const config = getConfig()
const giftMultipleCurrenciesActive = !!_get(config, ['features', 'gift', 'multipleCurrencies'])
const appDownloadBannerEnabled = !!_get(config, ['features', 'appDownloadBanner', 'enabled'])
// Circles config killswitch (FEATURES_CIRCLES_ENABLED). The authoritative gate.
// Per-user visibility is MEMBERSHIP (circles.length > 0), decided inside
// CirclesNavEntry — this mount-level check is the synchronous half (HeaderV2 is
// a class component, so no hook here) and keeps the connectStaticText boundary
// from mounting at all when the feature is off.
const circlesEnabled = !!_get(config, ['features', 'circles', 'enabled'])
const EMPTY_LIST = List()

function closeModal () {
  deactivateSubject({ campaign: 'WA-10' })
}

function onClickLoginButton (e, setOverlayDialogVisible, dialogName) {
  e.stopPropagation()
  e.preventDefault()
  setOverlayDialogVisible(dialogName)
}

function renderLoginButton (
  auth,
  setOverlayDialogVisible,
  dialogName,
  text,
  userLanguage,
) {
  if (auth.get('jwt')) {
    return null
  }

  const baseClassName = 'header__action-button'
  const buttonClassName = [
    'button--x-small',
    'button--secondary',
    'button--test',
    baseClassName,
    `${baseClassName}--left`,
  ].concat(userLanguage ? `${baseClassName}--${userLanguage}` : [])
  return (
    <Button
      type={TYPES.SECONDARY}
      className={buttonClassName.join(' ')}
      onClick={_partial(
        onClickLoginButton,
        _partial.placeholder,
        setOverlayDialogVisible,
        dialogName,
      )}
    >
      {text}
    </Button>
  )
}

function renderButtonSignUp (auth, text, userLanguage) {
  if (auth.get('jwt')) {
    return null
  }
  const baseClassName = 'headerV2__action-button'
  const buttonClassName = [
    'button--last',
    'button--x-small',
    'button--primary',
    'headerV2__button--signup',
    baseClassName,
  ].concat(userLanguage ? `${baseClassName}--${userLanguage}` : [])
  return (
    <ButtonSignUp
      text={text}
      buttonClass={buttonClassName}
      type={BUTTON_SIGN_UP_TYPE_BUTTON}
      scrollToTop
    />
  )
}

function shouldRenderLanguageSelectGlobe (auth) {
  const allowedRoles = [ROLE_ID_QA, ROLE_ID_SITE_ADMIN, ROLE_ID_DEVELOPER, ROLE_ID_EDITOR]
  const roleIds = auth.get('roleIds', List())
  const isUnauthenticated = !auth.get('jwt')
  const roleIsAllowed = allowedRoles.reduce((acc, nextRole) => {
    if (acc === true || roleIds.includes(nextRole)) {
      return true
    }
    return false
  }, false)

  if (isUnauthenticated || roleIsAllowed) {
    return true
  }
  return false
}

function renderLanguageSelectGlobe (props, setNavigationClickEvent, darkMode) {
  const { auth, location } = props

  if (
    location.pathname === URL_CART_BILLING
    || location.pathname === URL_CART_BILLING_PAYMENT
    || location.pathname === URL_CART_CONFIRMATION
    || !shouldRenderLanguageSelectGlobe(auth)
  ) {
    return null
  }

  return (
    <LanguageSelectGlobe setNavigationClickEvent={setNavigationClickEvent} darkMode={darkMode}/>
  )
}

class HeaderV2 extends Component {
  constructor (props) {
    super(props)

    const showLogin = _get(props, ['location', 'query', 'login'])
    if (showLogin) {
      props.setOverlayDialogVisible(TYPE_LOGIN)
    }
  }

  componentDidUpdate (prevProps) {
    const { props } = this
    const { path, resetHeaderNav } = props
    const { path: prevPath } = prevProps
    if (path !== prevPath) {
      resetHeaderNav()
    }
  }

  onClickHamburger = (e) => {
    e.stopPropagation()
    const { props } = this
    const {
      toggleNavigationOverlayVisible,
      showInviteFriendPopup,
      userReferrals,
      setEventDefault,
      navVersion,
    } = props
    const shouldCloseInviteFriendPopup = userReferrals.getIn(['showInviteFriendPopup'])
    toggleNavigationOverlayVisible()
    if (shouldCloseInviteFriendPopup) {
      showInviteFriendPopup(false)
    }

    setEventDefault(getNavClickedGa4Event(navVersion).mergeDeep({
      nav_element: 'hamburger',
    }))
  }

  setNavigationClickEvent = (eventLabel, eventElement) => {
    if (!eventLabel) return
    const { props } = this
    const {
      setEventDefault,
      navVersion,
    } = props
    // GA4 event
    setEventDefault(getNavClickedGa4Event(navVersion).mergeDeep({
      nav_element: eventElement,
    }))
  }

  isAuthorized = (item = Map()) => {
    const { props } = this
    const { auth = Map() } = props
    const isAuthorized = auth.get('uid', null)
    const authorize = item.get('auth', null)
    return authorize === null
      || (authorize === true && isAuthorized)
      || (authorize === false && !isAuthorized)
  }

  hasSubnav = (items = List()) => {
    const activeItem = items.find((i) => this.isActiveItem(i))
    // A popup item (e.g. Divination) renders its children as a hover DROPDOWN,
    // never as the sub-nav pill bar — reserving the bar's 53px (margin-increased)
    // for it leaves an empty band under the header on its routes.
    return activeItem
      && !activeItem.get('hasPopup', false)
      && activeItem.has('children') && activeItem.get('children').size > 0
  }

  isActiveItem = (item = Map()) => {
    const { props } = this
    const { resolver } = props
    const pathname = resolver.get('path')

    if (this.isAuthorized(item)) {
      const itemUrl = item.get('url')
      const isActive = itemUrl === pathname || isPartialPathAllowed(pathname, itemUrl)
      const children = item.get('children', List())
      if (!isActive && children && children.size) {
        return children.find((child) => this.isActiveItem(child))
      }
      return isActive
    }
    return false
  }

  render () {
    const { props, setNavigationClickEvent } = this
    const {
      setOverlayDialogVisible,
      staticTextHeader,
      overlayVisible,
      userLanguage,
      dismissModal,
      isGiftCompatible,
      hideUserMenu,
      hideNavBar,
      hideLogin,
      location,
      navItems,
      history,
      auth,
      testarossa,
      navVersion,
      darkMode,
      memberHomeFirstTouchHeader,
    } = props

    const firstTouch = !!(memberHomeFirstTouchHeader && memberHomeFirstTouchHeader.get('visible'))
    const firstTouchColorScheme = memberHomeFirstTouchHeader && memberHomeFirstTouchHeader.get('colorScheme')

    // The circles mark is a PNG (no currentColor tint) — the pure helper maps
    // the header's color state to the white/black asset (truth table tested in
    // getCirclesIconVariant.unit.ts).
    const circlesIconVariant = getCirclesIconVariant({
      darkMode, firstTouch, firstTouchColorScheme,
    })

    const shouldRenderGift = isGiftCompatible === GIFT_READY_STATE.CAN_PURCHASE
    const language = userLanguage.get(0, _get(config, ['appLang']))
    const isLoggedIn = getAuthIsLoggedIn(auth)
    const hasVariationV3 = !!testarossa.get('records', List()).find((record) => record.getIn(['variation', 'name'], '') === 'VariationV3')
    const hasSubNav = this.hasSubnav(fromJS(navItems))
    const headerClassName = [
      'headerV2',
      !hasVariationV3 && hasSubNav ? 'margin-increased' : null,
      darkMode && !firstTouch ? 'headerV2--dark-mode' : null,
      firstTouch ? 'headerV2--first-touch' : null,
      firstTouch && firstTouchColorScheme ? `headerV2--first-touch-${firstTouchColorScheme}` : null,
    ].filter((cls) => !!cls).join(' ')

    return (
      <header className={headerClassName} role="banner">
        {appDownloadBannerEnabled && <AppDownloadBanner location={location}/>}
        <AlertBarLoader history={history} location={location} />
        <div className="headerV2__top">
          {hideNavBar ? null : (
            <Hamburger
              navigationOverlayVisible={overlayVisible}
              className="headerV2__hamburger headerV2__hamburger--top-line-nav"
              onClick={this.onClickHamburger}
            />
          )}
          <div className="headerV2__branding">
            <GaiaLogo
              onClick={() => { setNavigationClickEvent(NAVIGATION_EVENT_LABELS.LOGO, 'logo') }}
              type={TYPE_TEAL}
              className={['headerV2__logo']}
              isHref
            />
          </div>
          <NavigationPrimaryV2
            history={history}
            navItems={navItems}
            navVersion={navVersion}
            darkMode={darkMode}
            hideNavBar={hideNavBar}
          />
          <div className={isLoggedIn ? 'headerV2__actions' : 'headerV2__not-auth-actions'}>
            {hideLogin
              ? null
              : renderLoginButton(
                auth,
                setOverlayDialogVisible,
                TYPE_LOGIN,
                staticTextHeader.getIn(['data', 'login']),
                language,
                location,
              )}
            {hideNavBar
              ? null
              : renderButtonSignUp(
                auth,
                staticTextHeader.getIn(['data', 'signUp']),
                language,
              )}
            {
              hideNavBar || !isLoggedIn
                ? null
                : renderLanguageSelectGlobe(props, setNavigationClickEvent, darkMode)
            }
            {((hideNavBar && !shouldRenderGift) || (!hideNavBar && shouldRenderGift)) ? (
              <Link
                onClick={() => { setNavigationClickEvent('gift', 'gift icon') }}
                target={giftMultipleCurrenciesActive ? null : TARGET_BLANK}
                to={giftMultipleCurrenciesActive ? getGiftLpUrl(getPrimary(userLanguage)) : URL_GIFT_LP}
                className="headerV2__action-gift"
                query={{ gift_source: 'gift' }}
                aria-label={staticTextHeader.getIn(['data', 'giftMembership'], 'Gift a membership')}
              >
                <IconV2 type={ICON_TYPES.GIFT_OUTLINE} />
              </Link>
            ) : null}
            {hideNavBar || !isLoggedIn ? null : (
              <NotificationsMenu color={darkMode ? 'white' : 'black'} setNavigationClickEvent={setNavigationClickEvent} />
            )}
            {hideNavBar || !isLoggedIn || !circlesEnabled ? null : (
              // Config killswitch gates the mount (OpenShift/Helm); membership
              // (the viewer has at least one joined circle) gates per-user
              // inside CirclesNavEntry. Both layers required.
              <CirclesNavEntry iconVariant={circlesIconVariant} />
            )}
            {/* If a user is logged in, the user menu shows */}
            {hideLogin ? null : (
              <MenuUser hideUserMenu={hideUserMenu} setNavigationClickEvent={setNavigationClickEvent} />
            )}
          </div>
        </div>
        <DaytonaCampaign id="WA-10">
          {(c, v) => {
            props.renderModal(TYPE_DAYTONA_WA_10, {
              onDismiss: () => closeModal(),
              className: 'wa-10',
              close: dismissModal,
              title: _get(v, ['data', 'title', 'value'], ''),
              c,
              v,
            })
          }}
        </DaytonaCampaign>
        {isLoggedIn ? <InviteFriendPopup /> : null}
      </header>
    )
  }
}

HeaderV2.propTypes = {
  isGiftCompatible: PropTypes.string,
  hideUserMenu: PropTypes.bool.isRequired,
  hideNavBar: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  hideLogin: PropTypes.bool.isRequired,
  history: PropTypes.object,
  navVersion: PropTypes.string,
  darkMode: PropTypes.bool,
  memberHomeFirstTouchHeader: ImmutablePropTypes.map,
}

export default connectRedux(

  (state) => ({
    auth: state.auth,
    path: state.resolver.get('path'),
    overlayVisible: state.header.get('navigationOverlayVisible'),
    staticTextHeader: state.staticText.getIn(['data', 'header'], Map()),
    userLanguage: state.user.getIn(['data', 'language'], EMPTY_LIST),
    userReferrals: state.userReferrals,
    userStore: state.user,
    featureTracking: state.featureTracking,
    resolver: state.resolver,
    testarossa: state.testarossa,
    memberHomeFirstTouchHeader: selectMemberHomeFirstTouchHeaderContext(state),
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      renderModal: actions.dialog.renderModal,
      dismissModal: actions.dialog.dismissModal,
      resetHeaderNav: actions.header.resetHeaderNav,
      toggleNavigationOverlayVisible: actions.header.toggleNavigationOverlayVisible,
      setNavigationOverlayVisible: actions.header.setNavigationOverlayVisible,
      setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
      showInviteFriendPopup: actions.userReferrals.showInviteFriendPopup,
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  },
)(HeaderV2)
